<template>
  <div>
    <AccOrderList :contact-id="contactId" />
  </div>
</template>

<script>
import AccOrderList from './AccOrderList.vue';

export default {
  components: {
    AccOrderList,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
};
</script>
